import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getAppointmentQueue } from 'api/Appointment';

export const useAppointmentsQueue = (params, options) => {
  const navigate = useNavigate();

  const { limit, sort, page, filters } = params;

  return useQuery(
    ['appointment-events', limit, sort, page, filters],
    () => getAppointmentQueue(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      ...options
    }
  );
};
